import { render, staticRenderFns } from "./Rdvs.vue?vue&type=template&id=f83b5dea&"
import script from "./Rdvs.vue?vue&type=script&lang=js&"
export * from "./Rdvs.vue?vue&type=script&lang=js&"
import style0 from "./Rdvs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports